/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessProducts.internal

import features.userBusinessProducts.models.UserProductsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessProductsRequest : NetworkRequest() {

    suspend fun getUserBusinessProducts(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<UserProductsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessProductsEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
